import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/style.css";
import { auth, db } from "./firebase";
import NetworkTopologies from "./NetworkTopologies";
import firebase from "firebase/compat/app";
import { Element, scroller } from "react-scroll";

const Chapter4_1 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question:
        "Frage 1: Was ist die Hauptaufgabe eines Routers in einem Netzwerk?",
      options: [
        {
          value: "A",
          label:
            "Er verbindet verschiedene Netzwerke miteinander und leitet Datenpakete basierend auf IP-Adressen weiter.",
        },
        {
          value: "B",
          label:
            "Er speichert Datenpakete temporär und verteilt sie gleichmäßig auf alle Netzwerkgeräte.",
        },
      ],
      correct: "A",
    },
    {
      question:
        "Frage 2: Welcher Netzwerktyp wird typischerweise in großen Organisationen verwendet, um mehrere Standorte über große Entfernungen hinweg zu verbinden?",
      options: [
        {
          value: "A",
          label:
            "Ein Wide Area Network (WAN) wird verwendet, um Netzwerke über weite Entfernungen zu verbinden.",
        },
        {
          value: "B",
          label:
            "Ein Metropolian Area Network (MAN) wird verwendet, um Netzwerke über verschiedene Metropolen hinweg zu verbinden.",},
      ],
      correct: "A",
    },
  ];
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      scroller.scrollTo(location.hash.substring(1), {
        duration: 500,
        smooth: true,
        offset: -50,
      });
    }
  }, [location]);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/cybersecurity/login"); 
      }
    });

   
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 4_1.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    
    auth
      .signOut()
      .then(() => {
        
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

        
        const userDoc = await db.collection("cybersecurityProgress").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
          
          await db
            .collection("cybersecurityProgress")
            .doc(userId)
            .update({
              lastChapter: "4_1",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("4_1"),
            });
          console.log("Dokument aktualisiert mit Kapitel 4_1.");
        } else {
          
          await db
            .collection("cybersecurityProgress")
            .doc(userId)
            .set({
              lastChapter: "4_1",
              completedChapters: ["4_1"],
            });
          console.log("Dokument erstellt mit Kapitel 4_1.");
        }

        navigate("/cybersecurity/4_2"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };

  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/cybersecurity/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/cybersecurity/course-overview"
                >
                  Netzwerk und Netzwerksicherheit
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                Was ist ein Netzwerk?
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-3">
            Kapitel 4: Netzwerk und Netzwerksicherheit
          </h3>
          <h2 className="text-center p-3">Was ist ein Netzwerk?</h2>
          <img
            src="/images/netzwerk.webp"
            alt="Netzwerk"
            style={{ position: "relative", maxWidth: "30%", height: "auto" }}
          />
        </div>

        <div className="p-5 text-center">
          <p className="col-lg-11 mx-auto">
            Netzwerke sind überall um uns herum und werden in vielen Bereichen
            genutzt.
            <br />
            <br />
            Ein <strong>Heimnetzwerk </strong> verbindet in deinem Zuhause
            Geräte wie Computer, Drucker, Smartphones, Smart-TVs und sogar
            Smart-Home-Geräte wie Thermostate oder Lampen.
            <br />
            <br />
            <strong>Unternehmensnetzwerke</strong> sind komplexere Netzwerke. Sie
            ermöglichen es Mitarbeitern, Daten auszutauschen, auf zentrale
            Server zuzugreifen und gemeinsam an Projekten zu arbeiten, egal ob
            sie im Büro nebenan oder in einem anderen Teil der Welt sitzen.
            Unternehmensnetzwerke vereinfachen die Anbindung an gemeinsame
            Hardware wie Drucker, wodurch jeder Computer im Netzwerk Zugriff
            darauf hat, ohne individuelle Verbindungen herstellen zu müssen.
            <br />
            <br />
            <strong>Cloud-Netzwerke</strong> ermöglichen von jedem beliebigen Standort den Zugriff
            auf Online-Dienste und -Speicher, wie z. B. Google Drive oder Dropbox.
            Dort werden Daten gespeichert, die dadurch ebenfalls von überall zu erreichen
            sind.
            <br />
            <br />
            <strong>IoT-Netzwerke</strong> (Internet of Things-Netzwerke)
            bestehen aus miteinander verbundenen Geräten, Sensoren, Aktoren und
            anderen physischen Objekten, die Daten über das Internet austauschen
            und miteinander interagieren können. Diese Geräte sind in der Regel
            mit Software, Sensoren und Netzwerkkonnektivität ausgestattet, um
            Informationen zu sammeln, zu verarbeiten und Aktionen auszuführen.
            So kann dein Kühlschrank beispielsweise eine Nachricht senden,
            wenn die Milch leer ist. <br />
            <br />
            Netzwerke bilden also eine Infrastruktur, die es uns ermöglicht,
            Daten zu senden, zu empfangen und auf Informationen zuzugreifen,
            unabhängig davon, wo wir uns befinden.
          </p>

          <p className="col-lg-11 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
            <img
              src="/images/fact.svg"
              alt="Transparent"
              style={{
                position: "relative",
                maxWidth: "8%",
                height: "auto",
              }}
            />
            Vor der Verbreitung von Netzwerken war das "Sneakernet" oft die
            schnellste Methode, große Datenmengen zu übertragen. Der Begriff
            "Sneakernet" beschreibt scherzhaft die Übertragung von Daten durch
            physisches Transportieren von Speichermedien (z. B. USB-Sticks,
            Festplatten) zwischen Computern, anstatt sie über ein Netzwerk zu
            senden.
          </p>
        </div>
      </div>

      <div className="grey-section pb-5">
        <div className="container pb-5">
          <div className="p-5 text-center">
            <h3 className="p-5 mt-5">
              Die zentralen Komponenten eines Netzwerks
            </h3>

            <div class="row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-3 g-3 pt-5">
              <div class="col d-flex align-items-start">
                <div class="p-3">
                  <img
                    src="/images/router.png"
                    alt="Transparent"
                    style={{
                      maxWidth: "12%",
                      height: "auto",
                    }}
                  />{" "}
                  <h4 class="m-3">Router</h4>
                  <p>
                    Der Router leitet Datenpakete zwischen verschiedenen
                    Netzwerken, z. B. zwischen einem Heimnetzwerk und dem
                    Internet zum richtigen Ziel. Dabei übernimmt er die Funktion
                    eines <strong>Verkehrsleiters </strong> und entscheidet,
                    welche Route die Daten nehmen sollen, basierend auf
                    Kriterien wie Verfügbarkeit, Geschwindigkeit und Sicherheit.
                  </p>
                </div>
              </div>
              <div class="col d-flex align-items-start">
                <div class="p-3">
                  <img
                    src="/images/switch.png"
                    alt="Transparent"
                    style={{
                      maxWidth: "12%",
                      height: "auto",
                    }}
                  />{" "}
                  <h4 class="m-3">Switch</h4>
                  <p>
                    Ein Switch sorgt dafür, dass ein Datenpaket
                    weitergeleitet wird, allerdings nur innerhalb eines
                    (lokalen) Netzwerks. Er verbindet wie eine{" "}
                    <strong>Kommunikationszentrale </strong> innerhalb eines Netzwerks Geräte wie Computer, Drucker und Server. Er
                    stellt sicher, dass das Datenpaket an das richtige
                    Zielgerät gelangt.
                  </p>
                </div>
              </div>

              <div class="col d-flex align-items-start">
                <div class="p-3">
                  <img
                    src="/images/firewallicon.webp"
                    alt="Transparent"
                    style={{
                      maxWidth: "10%",
                      height: "auto",
                    }}
                  />{" "}
                  <h4 class="m-3">Firewall</h4>
                  <p>
                    Firewalls sind die erste <strong>Schutzmauer </strong> des
                    Netzwerks gegen unerwünschte Zugriffe und Cyberangriffe. Sie
                    überwachen den ein- und ausgehenden Datenverkehr und
                    blockieren unerwünschte oder potenziell gefährliche
                    Verbindungen. Firewalls können hardware- oder softwarebasiert sein und schützen das Netzwerk vor externen Bedrohungen.
                  </p>
                </div>
              </div>
            </div>

            <div class="row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-3 g-3 pt-5">
              <div class="col d-flex align-items-start">
                <div class="p-3">
                  <img
                    src="/images/laptop.png"
                    alt="Transparent"
                    style={{
                      maxWidth: "12%",
                      height: "auto",
                    }}
                  />{" "}
                  <h4 class="m-3">Endgeräte (Clients)</h4>
                  <p>
                    Clients sind die Endgeräte der Benutzer, wie PCs, Laptops,
                    Smartphones oder Tablets. Sie greifen auf die von Servern
                    bereitgestellten Dienste und Ressourcen zu und ermöglichen
                    den Benutzern die Interaktion mit dem Netzwerk.
                  </p>
                </div>
              </div>
              <div class="col d-flex align-items-start">
                <div class="p-3">
                  <img
                    src="/images/server.png"
                    alt="Transparent"
                    style={{
                      maxWidth: "12%",
                      height: "auto",
                    }}
                  />{" "}
                  <h4 class="m-3">Server</h4>
                  <p>
                    Server sind leistungsstarke Computer, die wie ein großes
                    Lagerhaus die zentrale Dienste und Ressourcen für andere
                    Geräte im Netzwerk bereitstellen. Dazu gehören
                    beispielsweise Datei-, Druck-, E-Mail- und Webserver. Server
                    bilden das Herzstück vieler Netzwerke und ermöglichen eine
                    effiziente Verwaltung und die Nutzung gemeinsamer Ressourcen.
                  </p>
                </div>
              </div>
              <div class="col d-flex align-items-start">
                <div class="p-3">
                  <img
                    src="/images/kabel.png"
                    alt="Transparent"
                    style={{
                      maxWidth: "12%",
                      height: "auto",
                    }}
                  />{" "}
                  <h4 class=" m-3">Kabel und Funkverbindung</h4>
                  <p>
                    Sie sind der "Weg", über den die Daten reisen.
                    Ethernet-Kabel sind die am häufigsten verwendeten
                    Verkabelungsoptionen für lokale Netzwerke, während
                    Glasfaserkabel für Hochgeschwindigkeitsverbindungen über
                    große Entfernungen genutzt werden. Funkverbindungen wie WLAN
                    ermöglichen eine flexible und mobile Anbindung von Geräten.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="pb-5 text-center">
          <p className="col-lg-7 mx-auto d-inline-flex p-5 text-decoration-none border-beispiel rounded-2">
            <img
              src="/images/attack.svg"
              alt="Angriff"
              style={{
                position: "relative",
                maxWidth: "10%",
                height: "auto",
              }}
            />
            Es wird geschätzt, dass alle 39 Sekunden ein Cyberangriff auf ein
            Netzwerk stattfindet. Das macht die Bedrohung zu einem ständigen Risiko
            für Unternehmen und Organisationen. Viele dieser Angriffe
            nutzen bekannte Schwachstellen aus, die in veralteten
            Softwareversionen oder schlecht konfigurierten Netzwerken zu finden
            sind.
          </p>
        </div>
      </div>

      <div className="white-section">
        <div className="container ">
          <div className="p-5 text-center">
            <h3 className="p-5">Netzwerktypen</h3>

            <p className="col-lg-11 mx-auto">
              Je nach geografischer Ausdehnung und dem Anwendungsbereich
              unterscheiden sich Netzwerke hinsichtlich ihrer Klassifizierung:
            </p>
          </div>
        </div>
        <div className="container mb-5">
          <div className="col-lg-11 mx-auto">
            <div className="row">
              <table
                class="table table-light
                 table-striped-columns  mb-5 fs-5"
              >
                <thead>
                  <tr>
                    <th scope="col">Netzwerktyp</th>
                    <th scope="col">Beschreibung</th>
                    <th scope="col">Beispiel</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">
                      PAN <br />
                      <small>(Personal Area Network)</small>
                    </th>
                    <td>
                      Kleinste Netzwerkart, die persönliche Geräte im
                      unmittelbaren Umfeld eines Benutzers (ca. 10 Meter)
                      verbindet.
                    </td>
                    <td>
                      Verbindung zwischen Smartphone und kabellosen Kopfhörern.
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">
                      LAN
                      <br /> <small>(Local Area Network)</small>{" "}
                    </th>
                    <td>
                      Verbindet Computer und Geräte innerhalb eines begrenzten
                      geografischen Bereichs, wie einem Gebäude oder Campus.
                    </td>
                    <td>
                      Das Netzwerk eines Unternehmens in einem Bürogebäude.
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">
                      MAN <br />
                      <small>(Metropolitan Area Network)</small>{" "}
                    </th>
                    <td>
                      Größer als ein LAN, aber kleiner als ein WAN, erstreckt
                      sich über ein städtisches Gebiet (bis zu 100 km).
                    </td>
                    <td>
                      Netzwerk einer Universität, das verschiedene Campusgebäude
                      miteinander verbindet.
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">
                      WAN
                      <br /> <small>(Wide Area Network)</small>{" "}
                    </th>
                    <td>
                      Verbindet mehrere LANs über große Entfernungen hinweg, oft
                      über Länder und Kontinente.
                    </td>
                    <td>
                      Das Internet, das mehrere verschiedene Netzwerke
                      miteinander verbindet.
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">
                      WLAN <br /> <small>(Session Layer)</small>
                    </th>
                    <td>
                      Drahtloses lokales Netzwerk, das Geräte über Funkwellen
                      miteinander verbindet.
                    </td>
                    <td>
                      WLAN in einem Café, das Kunden für den Internetzugang zur
                      Verfügung steht.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div className="grey-section">
        <div className="container p-5">
          <div className="p-5 text-center">
            <h3 className="p-5">Netzwerktoplogien</h3>

            <p className="col-lg-11 mx-auto">
              Die Topologie eines Netzwerks beschreibt die Art und Weise, wie
              die Geräte innerhalb eines Netzwerks physisch oder logisch
              miteinander verbunden sind. Die Wahl der Topologie hat einen
              erheblichen Einfluss auf die Netzwerkleistung, Fehlertoleranz und
              Erweiterbarkeit. Es gibt verschiedene Netzwerktopologien, jede mit
              ihren eigenen Vor- und Nachteilen:
              <br />
              <br />
              <NetworkTopologies />
            </p>
          </div>
        </div>
      </div>

      <div className="white-section mt-5">
        <div className="container pb-5">
          <div className="container mt-5">
            <div
              className="safe rounded-2 text-center"
              style={{ backgroundColor: "#fec748" }}
            >
              <img
                src="/images/abwehr.svg"
                alt="Abwehr"
                style={{
                  position: "relative",
                  maxWidth: "7%",
                  height: "auto",
                }}
              />
              <Element name="pam">
                <h3 className="p-5"> Privileged Access Management (PAM)</h3>
                <p className="col-lg-11 mx-auto">
                  Netzwerke werden von Admins, IT-Support-Mitarbeitern oder
                  externen Dienstleistern verwaltet. Diese sogenannten{" "}
                  <strong> privilegierten Benutzer, </strong> müssen für ihre
                  Arbeit weitreichende Berechtigungen haben, die es ihnen
                  ermöglichen, Systeme zu konfigurieren, sensible Daten zu
                  ändern oder Software zu installieren. Ein Missbrauch oder ein
                  Kompromittieren solcher Konten stellt daher ein erhebliches
                  Sicherheitsrisiko dar.
                  <br />
                  <br />
                  Das <strong>Privileged Access Management (PAM) </strong> ist
                  eine Sicherheitslösung, die den Zugriff von privilegierten
                  Benutzerkonten auf kritische Systeme und Daten kontrolliert
                  und absichert. <br />
                  <br />
                  PAM bietet unter anderem folgende Funktionen:
                </p>
                <p className="col-lg-11 text-start mx-auto">
                  <ul>
                    <li>
                      <strong>
                        Zentralisierte Verwaltung privilegierter Konten:{" "}
                      </strong>{" "}
                      Alle privilegierten Konten werden zentral überwacht und
                      verwaltet.
                    </li>
                    <br />
                    <li>
                      <strong>Zugriffskontrolle: </strong> Nur autorisierte
                      Personen dürfen auf sensible Systeme zugreifen.
                    </li>
                    <br />
                    <li>
                      <strong>
                        Session-Überwachung und -Protokollierung:{" "}
                      </strong>{" "}
                      Aktivitäten privilegierter Konten werden protokolliert und
                      können in Echtzeit überwacht werden.
                    </li>
                    <br />
                    <li>
                      <strong>Passwortrotation und -verwaltung: </strong>{" "}
                      Passwörter für privilegierte Konten werden regelmäßig
                      automatisch geändert, um Risiken durch statische
                      Zugangsdaten zu minimieren.
                    </li>
                    <br />
                    <li>
                      <strong>Zeitlich begrenzte Zugriffe: </strong> Benutzer
                      erhalten privilegierte Zugriffsrechte nur für eine
                      begrenzte Zeit und für spezifische Aufgaben.
                    </li>
                  </ul>
                </p>
              </Element>
            </div>
          </div>

          {/* Fragenteil */}
          <div className="container pt-5 my-5">
            <div className="text-center m-4">
              <h2>Überprüfe dein Wissen</h2>
              <p className="col-lg-11 mx-auto">
                Mit den richtigen Antworten kommst du weiter!
              </p>
            </div>
            <div className="row justify-content-center">
              <div className="col-md-10 text-start">
                <form onSubmit={handleSubmit}>
                  {questions.map((question, index) => (
                    <div key={index} className="mb-4">
                      <p className="fs-4">{question.question}</p>{" "}
                      {question.options.map((option) => (
                        <div key={option.value} className="form-check">
                          <input
                            className="form-check-input me-2"
                            type="radio"
                            name={`question${index}`}
                            value={option.value}
                            checked={selectedAnswers[index] === option.value}
                            onChange={() =>
                              handleAnswerChange(index, option.value)
                            }
                          />
                          <label className="form-check-label fs-5">
                            {option.label}
                          </label>{" "}
                        </div>
                      ))}
                    </div>
                  ))}
                  {error && <p className="text-danger">{error}</p>}
                  <div className="text-center">
                    <button type="submit" className="btn btn-primary">
                      überprüfen
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {/* Ende Fragenteil */}
        </div>
      </div>
    </div>
  );
};

export default Chapter4_1;
